import { useLockBodyScroll } from '@/utils/useLockBodyScroll';
import { useFreeShippingActivatedPopup } from '@/data/Content/FreeShippingActivatedPopup';
import { AuthentificationFlow } from '@/components/blocks/AuthentificationFlow';
import { FreeShippingActivatedPopupDialog } from '@/components/blocks/FreeShippingActivatedPopup/parts/FreeShippingActivatedPopupDialog';

export interface FreeShippingActivatedPopupProps {
	id?: string | number;
	title?: string;
	description?: string;
	descriptionSecondItem?: string;
	products: { [gender: string]: string };
	discount?: number;
	onUnavailable?: () => void;
}

export const FreeShippingActivatedPopup: React.FC<FreeShippingActivatedPopupProps> = ({
	id,
	title,
	description,
	descriptionSecondItem,
	products,
	discount,
	onUnavailable,
}) => {
	const {
		productInfo,
		appliesSecondItemDiscount,
		productSelected,
		productHref,
		hideSizeSelect,
		openPopup,
		openAuthAddCartFlow,
		openAuthRedirectFlow,
		onClosePopup,
		onSelectProductSize,
		onAddToCart,
		onViewProduct,
		onAuthFlowClose,
		onAuthSuccess,
	} = useFreeShippingActivatedPopup(products, id, discount, onUnavailable);
	useLockBodyScroll(openPopup);

	const resolvedDescription =
		appliesSecondItemDiscount && descriptionSecondItem ? descriptionSecondItem : description;

	return (
		<>
			{productInfo ? (
				<FreeShippingActivatedPopupDialog
					open={openPopup}
					title={title}
					description={resolvedDescription}
					productInfo={productInfo}
					productSelected={productSelected}
					productHref={productHref}
					hideSizeSelect={hideSizeSelect}
					onClosePopup={onClosePopup}
					onSelectProductSize={onSelectProductSize}
					onAddToCart={onAddToCart}
					onViewProduct={onViewProduct}
				/>
			) : null}

			<AuthentificationFlow
				open={openAuthAddCartFlow}
				type="login"
				origin="quick_cart"
				onClose={onAuthFlowClose}
				onAuthSuccess={onAuthSuccess}
			/>
			<AuthentificationFlow
				open={openAuthRedirectFlow}
				type="login"
				origin="quick_cart"
				onClose={onAuthFlowClose}
			/>
		</>
	);
};
